import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  EnumPicker,
  EnumPickerProps,
} from '@work4all/components/lib/components/entity-picker/enum-picker/EnumPicker';
import { useLock } from '@work4all/components/lib/hooks';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface EnumPickerFieldProps extends Omit<EnumPickerProps, 'multiple'> {
  ref?: React.Ref<HTMLDivElement>;
  error?: string;
  label: string;
  disabled?: boolean;
  translationPrefix?: string;
}

export function EnumPickerField(props: EnumPickerFieldProps) {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const { ref, label, disabled, error, ...pickerProps } = props;
  const { value, onChange, translationPrefix } = pickerProps;

  const { locked } = useLock();

  const onClear = props.clearable ? () => onChange(null) : undefined;
  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        anchorEl={wrapperRef}
        disabled={disabled || locked}
        picker={<EnumPicker {...pickerProps} />}
      >
        <LabeledInput
          onClear={onClear}
          label={label}
          error={error}
          disabled={disabled || locked}
          value={
            value
              ? (t(`${translationPrefix || 'ENUMS'}.${value}`) as string)
              : ''
          }
        />
      </EntityPickerPopover>
    </div>
  );
}
